import { isDeviceMobile } from '../../../../helpers/helpers';

export default function DropDown({ label, fieldName, value, onInputChange }) {
  return (
    <div className="mb-3 w-100 d-flex flex-column">
      <label htmlFor={fieldName} className="form-label">
        {label}
      </label>

      <select
        id={fieldName}
        value={value}
        onChange={onInputChange}
        name={fieldName}
        className="form-select"
      >
        <option value="">Select a city</option>
        <option value="London">London</option>
        <option value="Manchester">Manchester</option>
        <option value="Other">Other Cities</option>
      </select>
    </div>
  );
}
